import { useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';
import { APITypes } from '../../primary-record-types';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import { NotesList } from '../../primary-record-types/apiTypes/notesService';
import { getOrganizationClientRecordNotesCacheKey } from './cacheKeys';

export type UsePastClientRecordNotesArgs = {
    organizationId: string;
    pastOrganizationClientRecordIds: string[];
};

export type UsePastClientRecordNotesReturnValue = {
    notes: APITypes.notesService.NoteListItem[];
    isLoading: boolean;
};

export default function usePastClientRecordNotes({
    organizationId,
    pastOrganizationClientRecordIds,
}: UsePastClientRecordNotesArgs): UsePastClientRecordNotesReturnValue {
    const queries = useQueries({
        queries: pastOrganizationClientRecordIds.map((organizationClientRecordId) => ({
            queryKey: getOrganizationClientRecordNotesCacheKey(organizationClientRecordId),
            queryFn: async () =>
                appAPI.get<NotesList>(
                    urls.api.notes.list.organizationClientRecordNotes(organizationId, organizationClientRecordId),
                ),
            enabled: !!organizationId && !!organizationClientRecordId,
        })),
    });

    const notes = useMemo(() => queries.flatMap((q) => q.data?.notes ?? []), [queries]);
    const isLoading = queries.some((q) => q.isLoading);

    return { notes, isLoading };
}
